(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-collapsible-text]';

  function initialize(scope = document) {
    const blocks = scope.matches?.(selector)
      ? [scope]
      : scope.querySelectorAll(selector);

    blocks.forEach((block) => {
      if (block.dataset.expanded === 'true') return;

      const excerpt = block.querySelector('[data-text-excerpt]');
      const full = block.querySelector('[data-text-full]');
      const button = block.querySelector('[data-text-toggle]');

      if (!excerpt || !full || !button) return;

      excerpt.hidden = false;
      full.hidden = true;
      button.hidden = true;

      const hasOverflow = excerpt.scrollHeight > excerpt.clientHeight + 1;

      if (hasOverflow) {
        button.hidden = false;
      } else {
        excerpt.hidden = true;
        full.hidden = false;
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-text-toggle]');
    if (!button) return;

    const block = button.closest(selector);
    if (!block) return;

    const excerpt = block.querySelector('[data-text-excerpt]');
    const full = block.querySelector('[data-text-full]');

    if (!excerpt || !full) return;

    const expanded = block.dataset.expanded !== 'true';

    if (expanded) {
      block.dataset.expanded = 'true';
      excerpt.hidden = true;
      full.hidden = false;
    } else {
      block.removeAttribute('data-expanded');
      excerpt.hidden = false;
      full.hidden = true;
    }

    button.textContent = expanded ? '−' : '+';
    button.setAttribute('aria-expanded', String(expanded));
    button.setAttribute(
      'aria-label',
      expanded ? 'Collapse description' : 'Show full description'
    );

    if (!expanded) {
      initialize(block);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialize(),
      { once: true }
    );
  } else {
    initialize();
  }

  if (document.fonts) {
    document.fonts.ready.then(() => initialize());
  }

  let resizeScheduled = false;

  window.addEventListener('resize', () => {
    if (resizeScheduled) return;

    resizeScheduled = true;

    requestAnimationFrame(() => {
      resizeScheduled = false;
      initialize();
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
